import { ISearchPromosV2ResponseSchema } from '../repositories/newbuilding-promos/entities/search_promos_v2/SearchPromosV2ResponseSchema';
import { THasNexPage } from '../types/hasNexPage';

export const mapHasNexPage = (promosResponse: ISearchPromosV2ResponseSchema): THasNexPage => {
  const hasNexPage = promosResponse.promoSearchResult.hasMore;

  return hasNexPage || false;
};
